import React from 'react';

const Newsletter = () => {
  return (
    <div className="bg-gradient-to-r from-purple-600 to-purple-800 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:scale-[1.02] relative group p-6 md:p-8 text-white mt-12 w-full">
      <h2 className="text-xl font-bold mb-2">Join The PHYT Community</h2>
      <p className="mb-4">Get weekly nutrition tips, workout plans, and exclusive offers delivered to your inbox.</p>
      <div className="flex flex-col sm:flex-row gap-2">
        <input 
          type="email" 
          placeholder="Your email address" 
          className="flex-1 py-3 px-4 rounded-lg text-gray-800 focus:outline-none focus:ring-2 focus:ring-purple-300"
        />
        <button className="px-6 py-3 bg-gradient-to-r from-white to-purple-100 text-purple-700 font-bold rounded-xl hover:shadow-xl transition-all duration-300 transform hover:scale-[1.02] group-hover:from-purple-50 group-hover:to-purple-200">
          Subscribe
        </button>
      </div>
    </div>
  );
};

export default Newsletter; 